var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-form",
              {
                ref: "formRef",
                staticClass: "company-info_form",
                attrs: {
                  model: _vm.form,
                  "label-width": "120px",
                  "label-position": _vm.getIsMobile ? "top" : "right",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "系统名称", prop: "xname" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入系统名称" },
                      model: {
                        value: _vm.form.xname,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "xname", $$v)
                        },
                        expression: "form.xname",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "公司全称", prop: "cname" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入公司全称" },
                      model: {
                        value: _vm.form.cname,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cname", $$v)
                        },
                        expression: "form.cname",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "英文全称", prop: "uname" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入英文全称" },
                      model: {
                        value: _vm.form.uname,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "uname", $$v)
                        },
                        expression: "form.uname",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "公司网址", prop: "wangzhi" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入公司网址" },
                      model: {
                        value: _vm.form.wangzhi,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "wangzhi", $$v)
                        },
                        expression: "form.wangzhi",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "发票类型", prop: "wangzhi" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入发票类型" },
                      model: {
                        value: _vm.form.fplx,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fplx", $$v)
                        },
                        expression: "form.fplx",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "logo", prop: "logo" } },
                  [
                    _c("Upload", {
                      attrs: { fileList: _vm.form.logo },
                      on: {
                        uploadChange: function (val) {
                          return (_vm.form.logo = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "合同章", prop: "contract_chapter" } },
                  [
                    _c("Upload", {
                      attrs: { fileList: _vm.form.contract_chapter },
                      on: {
                        uploadChange: function (val) {
                          return (_vm.form.contract_chapter = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "报价单章", prop: "quotation_contract" } },
                  [
                    _c("Upload", {
                      attrs: { fileList: _vm.form.quotation_contract },
                      on: {
                        uploadChange: function (val) {
                          return (_vm.form.quotation_contract = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "报价单编号", prop: "bjdbh" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "请输入报价单编号" },
                        model: {
                          value: _vm.form.bjdbh,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bjdbh", $$v)
                          },
                          expression: "form.bjdbh",
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("如: JZCY")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "合同编号", prop: "htbh" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "请输入合同编号" },
                        model: {
                          value: _vm.form.htbh,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "htbh", $$v)
                          },
                          expression: "form.htbh",
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("如: JZCY")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "公司地址", prop: "address" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入公司地址" },
                      model: {
                        value: _vm.form.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "address", $$v)
                        },
                        expression: "form.address",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "400热线", prop: "sill" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入400热线" },
                      model: {
                        value: _vm.form.sill,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sill", $$v)
                        },
                        expression: "form.sill",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "座机", prop: "mobile" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入座机" },
                      model: {
                        value: _vm.form.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mobile", $$v)
                        },
                        expression: "form.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "企业QQ", prop: "qyqq" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入企业QQ" },
                      model: {
                        value: _vm.form.qyqq,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "qyqq", $$v)
                        },
                        expression: "form.qyqq",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "E-mail", prop: "email" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入E-mail" },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "传真", prop: "max" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入传真" },
                      model: {
                        value: _vm.form.max,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "max", $$v)
                        },
                        expression: "form.max",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "税号", prop: "shuihao" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入税号" },
                      model: {
                        value: _vm.form.shuihao,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "shuihao", $$v)
                        },
                        expression: "form.shuihao",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "开户银行", prop: "bank" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入开户银行" },
                      model: {
                        value: _vm.form.bank,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bank", $$v)
                        },
                        expression: "form.bank",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "银行帐号", prop: "banknum" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入银行帐号" },
                      model: {
                        value: _vm.form.banknum,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "banknum", $$v)
                        },
                        expression: "form.banknum",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "发货人", prop: "fhmember" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入发货人" },
                      model: {
                        value: _vm.form.fhmember,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fhmember", $$v)
                        },
                        expression: "form.fhmember",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "发货备注", prop: "fhbz" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入发货备注" },
                      model: {
                        value: _vm.form.fhbz,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fhbz", $$v)
                        },
                        expression: "form.fhbz",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "editor",
                    attrs: { label: "报价单摘要", prop: "bjdzy" },
                  },
                  [
                    _c("div", {
                      ref: "summaryEditor",
                      staticClass: "summaryEditor",
                    }),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "editor",
                    attrs: { label: "报价单条款", prop: "bjdtk" },
                  },
                  [_c("div", { ref: "termEditor", staticClass: "termEditor" })]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "editor",
                    attrs: { label: "合同条款", prop: "content" },
                  },
                  [
                    _c("div", {
                      ref: "contractEditor",
                      staticClass: "contractEditor",
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("重 置"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }